export default function ETitle({ text, className }) {
  return (
    <h1 className={`text-lg font-bold md:text-3xl ${className}`}>{text}</h1>
  )
}
